import { render, staticRenderFns } from "./uploadBox.vue?vue&type=template&id=70afac60&scoped=true"
import script from "./uploadBox.vue?vue&type=script&lang=js"
export * from "./uploadBox.vue?vue&type=script&lang=js"
import style0 from "./uploadBox.vue?vue&type=style&index=0&id=70afac60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70afac60",
  null
  
)

export default component.exports